export const getObjectHeaderBreadcrumbsContentTitle = ({
	isSpaceOverviewPage,
	contentMode,
	editorTitle,
	contentTitle,
}: {
	isSpaceOverviewPage: boolean;
	contentMode: string | undefined;
	editorTitle: string | null;
	contentTitle: string | null | undefined;
}): string | undefined => {
	if (isSpaceOverviewPage) {
		// Pass an undefined string to contentTitle to prevent the breadcrumbs from rendering
		// a title when this is a Space Overview page
		return undefined;
	}

	// intentionally exclude live mode, we want to return published content title since live mode publishes their title on every change
	if (contentMode === 'edit' || contentMode === 'draft') {
		// pass the editorTitle as-is, even if it is an empty string (empty strings will be transformed into "Untitled")
		// pass in contentTitle if editorTitle is not available to prevent any breadcrumbs layout shifting during load (especially for drafts)
		return typeof editorTitle === 'string'
			? editorTitle
			: typeof contentTitle === 'string'
				? contentTitle
				: undefined;
	}

	return contentTitle ?? undefined;
};
